module.exports = __webpack_public_path__ + "e20cf2dea27fea8865191314fb7808e1.woff2";